import { action, atom } from "@reatom/framework";

export const createInvoiceModalOpen = atom(false, "createInvoiceModalOpen");

export type InvoiceResult =
  | { mode: "paid"; link: string; totalAmount: string }
  | { mode: "free" };

export const createInvoiceResult = atom<InvoiceResult | null>(
  null,
  "createInvoiceResult",
);

export const createInvoiceFormInvalid = atom<boolean>(
  false,
  "createInvoiceFormInvalid",
);

export const openCreateInvoiceModalAction = action((ctx) => {
  createInvoiceResult(ctx, null);
  createInvoiceFormInvalid(ctx, false);
  createInvoiceModalOpen(ctx, true);
}, "openCreateInvoiceModalAction");

export const closeCreateInvoiceModalAction = action((ctx) => {
  createInvoiceModalOpen(ctx, false);
  createInvoiceResult(ctx, null);
  createInvoiceFormInvalid(ctx, false);
}, "closeCreateInvoiceModalAction");
